import { Injectable, Inject } from '@angular/core';
import { StrictBehavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';

import { HttpClient } from '@angular/common/http';
import { OTP_CONTACT_ID, OTP_CONTACT_METHOD } from '../otp/otp-util';
import { TemplateGoToPage } from '../template/template-go-to-page';

@Injectable()
export class OtpVerifyCode extends StrictBehavior {
  static readonly ARGS = {
    url: {
      required: false,
      name: 'url',
      type: 'string',
      description: 'The base URL for OTP',
      default: 'https://vdc-qaswebapp08.stormwind.local/AppMeOrchestrator',
    },
    pageKey: {
      required: true,
      name: 'pageKey',
      type: 'string',
      description: 'The page key to navigate to on success',
    },
  };

  constructor(
    public http: HttpClient,
    @Inject('TemplateGoToPage') private templateGoToPage: TemplateGoToPage
  ) {
    super();
  }

  async executeBehavior(args: any, ctx: BehaviorContext): Promise<any> {
    if (!args.url) {
      args.url = OtpVerifyCode.ARGS.url.default;
    }
    const currentVal = ctx.formGroup.value[ctx.target.model.formControlName];
    const contactId = ctx.get(OTP_CONTACT_ID);
    const contactMethod = ctx.get(OTP_CONTACT_METHOD);

    try {
      //   await this.http
      //     .post(args.url, {
      //       AuthorizationId: contactId,
      //       oneTimePasswordValue: currentVal,
      //     })
      //     .toPromise();
      this.templateGoToPage.execute(
        {
          pageKey: args.pageKey,
        },
        ctx
      );
    } catch (err) {}
  }
}
